import { builderFragment } from './fragments.gql'

export default slug => `query {
  landingPage(filter: {slug: {eq: "${slug.replace('/', '__')}"}}) {
    productPanel
    animatedHeader
    products {
      sku
      title
      subTitle
      frameSwatchOverride
      lensSwatchOverride
      swatchIconOverride {
        url(imgixParams: {w: "50", h: "50"})
      }
      overrideLensName
      lensPart
      lensName
      stockManagedPart
      pageThemeOverride
    }
    slug
    ${builderFragment}
  }
}`
